module.exports = __webpack_public_path__ + "static/media/horizontalIcon.d12ee28e.svg";